import React, { useState } from "react";

export default function AccessData({
  buttonLoader,
  accessObject,
  handelAddData,
  setAccessDataList,
  accessDataList,
}) {
  console.log(":::::", accessObject, accessDataList);

  return (
    <div>
      {console.log("accessDataList?.email::: ", accessDataList)}
      <label className="mt-3 mb-3">
        Access User : {accessObject?.name + " (" + accessObject?.email + ")"}
      </label>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Dashboard</b>
        </h5>
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Dashboard Count</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="CountView"
                          defaultChecked={
                            accessObject?.access?.dashboardCount == true
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              dashboardCount:
                                e.target.checked === true ? true : false,
                            });
                          }}
                        />
                        <label for="CountView">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Admin</b>
        </h5>
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Admin List</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getAdminList"
                          defaultChecked={
                            accessObject?.access?.getAdminList == true
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getAdminList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                        />
                        <label for="getAdminList">View</label>
                      </div>
                      {console.log(
                        "accessDataList.getAdminList::: ",
                        accessDataList.getAdminList
                      )}
                      {accessDataList.getAdminList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="adminListAdd"
                              defaultChecked={
                                accessObject?.access?.getAdminList == true
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  getAdminList:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                            />
                            <label for="adminListAdd">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="adminListEdit"
                              defaultChecked={
                                accessObject?.access?.adminListEdit == true
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  adminListEdit:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                            />
                            <label for="adminListEdit">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="adminListDelete"
                              defaultChecked={
                                accessObject?.access?.adminListDelete == true
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  adminListDelete:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                            />
                            <label for="adminListDelete">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Admin Access</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="adminAccessUser"
                          defaultChecked={
                            accessObject?.access?.adminAccessUser == true
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              adminAccessUser:
                                e.target.checked === true ? true : false,
                            });
                          }}
                        />
                        <label for="adminAccessUser">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Player</b>
        </h5>
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            {console.log(
              " accessObject?.access?.getPlayerList == true::: ",
              accessObject?.access?.getPlayerList == true
            )}
            <table className="m-2">
              <thead>
                <th>Player List</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        {console.log(
                          " accessObject?.access?.getPlayerList::: ",
                          accessObject?.access?.getPlayerList
                        )}
                        <input
                          type="checkbox"
                          id="getPlayerList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getPlayerList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getPlayerList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getPlayerList">View</label>
                      </div>
                      {accessDataList?.getPlayerList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="playerListEdit"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  playerListEdit:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.playerListEdit == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="playerListEdit">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="playerListDelete"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  playerListDelete:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.playerListDelete == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="playerListDelete">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Player Banned</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getPlayerBannedList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getPlayerBannedList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getPlayerBannedList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getPlayerBannedList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Live Player App</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getLivePlayerAppList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getLivePlayerAppList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getLivePlayerAppList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getLivePlayerAppList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Live Player Game</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getLivePlayerGameList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getLivePlayerGameList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getLivePlayerGameList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getLivePlayerGameList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Tournament</b>
        </h5>
        <div className="row">
          {/* Block Blast */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Block Blast</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getBlockBlastTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getBlockBlastTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getBlockBlastTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getBlockBlastTour">View</label>
                      </div>
                      {accessDataList?.getBlockBlastTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addBlockBlastTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addBlockBlastTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addBlockBlastTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addBlockBlastTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editBlockBlastTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editBlockBlastTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editBlockBlastTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editBlockBlastTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteBlockBlastTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteBlockBlastTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteBlockBlastTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteBlockBlastTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* CandyCream */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Candy Cream</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getCandyCreamTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getCandyCreamTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getCandyCreamTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getCandyCreamTour">View</label>
                      </div>
                      {accessDataList?.getCandyCreamTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addCandyCreamTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addCandyCreamTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addCandyCreamTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addCandyCreamTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editCandyCreamTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editCandyCreamTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editCandyCreamTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editCandyCreamTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteCandyCreamTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteCandyCreamTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteCandyCreamTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteCandyCreamTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* LogicLine */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Logic Line</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getLogicLineTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getLogicLineTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getLogicLineTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getLogicLineTour">View</label>
                      </div>
                      {accessDataList?.getLogicLineTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addLogicLineTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addLogicLineTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addLogicLineTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addLogicLineTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editLogicLineTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editLogicLineTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editLogicLineTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editLogicLineTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteLogicLineTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteLogicLineTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteLogicLineTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteLogicLineTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* SmashBlock */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Smash Block</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getSmashBlockTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getSmashBlockTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getSmashBlockTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getSmashBlockTour">View</label>
                      </div>
                      {accessDataList?.getSmashBlockTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addSmashBlockTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addSmashBlockTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addSmashBlockTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addSmashBlockTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editSmashBlockTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editSmashBlockTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editSmashBlockTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editSmashBlockTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteSmashBlockTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteSmashBlockTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteSmashBlockTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteSmashBlockTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* TicTacToe */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Tic Tac Toe</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getTicTacToeTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getTicTacToeTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getTicTacToeTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getTicTacToeTour">View</label>
                      </div>
                      {accessDataList?.getTicTacToeTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addTicTacToeTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addTicTacToeTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addTicTacToeTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addTicTacToeTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editTicTacToeTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editTicTacToeTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editTicTacToeTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editTicTacToeTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteTicTacToeTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteTicTacToeTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteTicTacToeTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteTicTacToeTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* WordBook */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Word Book</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getWordBookTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getWordBookTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getWordBookTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getWordBookTour">View</label>
                      </div>
                      {accessDataList?.getWordBookTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addWordBookTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addWordBookTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addWordBookTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addWordBookTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editWordBookTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editWordBookTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editWordBookTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editWordBookTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteWordBookTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteWordBookTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteWordBookTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteWordBookTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* NumberPuzzle */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Number Puzzle</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getNumberPuzzleTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getNumberPuzzleTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getNumberPuzzleTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getNumberPuzzleTour">View</label>
                      </div>
                      {accessDataList?.getNumberPuzzleTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addNumberPuzzleTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addNumberPuzzleTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addNumberPuzzleTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addNumberPuzzleTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editNumberPuzzleTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editNumberPuzzleTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editNumberPuzzleTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editNumberPuzzleTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteNumberPuzzleTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteNumberPuzzleTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteNumberPuzzleTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteNumberPuzzleTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* ChessGameBit */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Chess Game Bit</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getChessGameBitTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getChessGameBitTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getChessGameBitTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getChessGameBitTour">View</label>
                      </div>
                      {accessDataList?.getChessGameBitTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addChessGameBitTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addChessGameBitTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addChessGameBitTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addChessGameBitTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editChessGameBitTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editChessGameBitTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editChessGameBitTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editChessGameBitTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteChessGameBitTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteChessGameBitTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteChessGameBitTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteChessGameBitTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* ClassyCarrom */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Classy Carrom</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getClassyCarromTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getClassyCarromTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getClassyCarromTour == true
                              ? true
                              : false
                          }
                        />
                        <label for="getClassyCarromTour">View</label>
                      </div>
                      {accessDataList?.getClassyCarromTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addClassyCarromTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addClassyCarromTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addClassyCarromTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addClassyCarromTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editClassyCarromTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editClassyCarromTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editClassyCarromTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editClassyCarromTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteClassyCarromTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteClassyCarromTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteClassyCarromTour ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteClassyCarromTour">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* EightBallPoolLite */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Eight Ball Pool Lite</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getEightBallPoolLiteTour"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getEightBallPoolLiteTour:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getEightBallPoolLiteTour ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getEightBallPoolLiteTour">View</label>
                      </div>
                      {accessDataList?.getEightBallPoolLiteTour == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addEightBallPoolLiteTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addEightBallPoolLiteTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access
                                  ?.addEightBallPoolLiteTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addEightBallPoolLiteTour">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editEightBallPoolLiteTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editEightBallPoolLiteTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access
                                  ?.editEightBallPoolLiteTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editEightBallPoolLiteTour">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteEightBallPoolLiteTour"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteEightBallPoolLiteTour:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access
                                  ?.deleteEightBallPoolLiteTour == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteEightBallPoolLiteTour">
                              Delete
                            </label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Controls</b>
        </h5>
        <div className="row">
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Notification</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getNotificationList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getNotificationList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getNotificationList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getNotificationList">View</label>
                      </div>
                      {accessDataList?.getNotificationList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="notificationAdd"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  notificationAdd:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.notificationAdd == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="notificationAdd">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="notificationDelete"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  notificationDelete:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.notificationDelete == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="notificationDelete">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Separate Notification</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getNotificationListSeparate"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getNotificationListSeparate:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getNotificationListSeparate ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getNotificationListSeparate">View</label>
                      </div>
                      {accessDataList?.getNotificationListSeparate == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="notificationSeparateSend"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  notificationSeparateSend:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access
                                  ?.notificationSeparateSend == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="notificationSeparateSend">Send</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Version Android</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getVersionListAndroid"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getVersionListAndroid:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getVersionListAndroid == true
                              ? true
                              : false
                          }
                        />
                        <label for="getVersionListAndroid">View</label>
                      </div>
                      {accessDataList?.getVersionListAndroid == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="versionEditAndroid"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  versionEditAndroid:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.versionEditAndroid == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="versionEditAndroid">Edit</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Version IOS</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getVersionListIos"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getVersionListIos:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getVersionListIos == true
                              ? true
                              : false
                          }
                        />
                        <label for="getVersionListIos">View</label>
                      </div>
                      {accessDataList?.getVersionListIos == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="versionEditIos"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  versionEditIos:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.versionEditIos == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="versionEditIos">Edit</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* BotForm */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Bot Form</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getBotForm"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getBotForm:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getBotForm == true
                              ? true
                              : false
                          }
                        />
                        <label for="getBotForm">View</label>
                      </div>
                      {accessDataList?.getBotForm == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addBotForm"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addBotForm:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addBotForm == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addBotForm">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editBotForm"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editBotForm:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editBotForm == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editBotForm">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteBotForm"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteBotForm:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteBotForm == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteBotForm">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Room tier */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Room Tier</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getRoomTier"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getRoomTier:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getRoomTier == true
                              ? true
                              : false
                          }
                        />
                        <label for="getRoomTier">View</label>
                      </div>
                      {accessDataList?.getRoomTier == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addRoomTier"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addRoomTier:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addRoomTier == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addRoomTier">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editRoomTier"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editRoomTier:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editRoomTier == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editRoomTier">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteRoomTier"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteRoomTier:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteRoomTier == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteRoomTier">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* RestrictedArea */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Restricted Area</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getRestrictedArea"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getRestrictedArea:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getRestrictedArea == true
                              ? true
                              : false
                          }
                        />
                        <label for="getRestrictedArea">View</label>
                      </div>
                      {accessDataList?.getRestrictedArea == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addRestrictedArea"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addRestrictedArea:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addRestrictedArea == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addRestrictedArea">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editRestrictedArea"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editRestrictedArea:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editRestrictedArea == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editRestrictedArea">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteRestrictedArea"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteRestrictedArea:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteRestrictedArea ==
                                true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteRestrictedArea">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Banner */}
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Banner</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getBannerList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getBannerList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getBannerList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getBannerList">View</label>
                      </div>
                      {accessDataList?.getBannerList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="bannerAdd"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  bannerAdd:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.bannerAdd == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="bannerAdd">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="bannerEdit"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  bannerEdit:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.bannerEdit == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="bannerEdit">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="bannerDelete"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  bannerDelete:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.bannerDelete == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="bannerDelete">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Payment</b>
        </h5>
        <div className="row">
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>History</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getHistoryList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getHistoryList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getHistoryList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getHistoryList">View</label>
                      </div>
                      {accessDataList?.getHistoryList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="historyDownload"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  historyDownload:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.historyDownload == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="historyDownload">Download</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Add Cash</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getAddCashList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getAddCashList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getAddCashList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getAddCashList">View</label>
                      </div>
                      {accessDataList?.getAddCashList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addCashDownload"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addCashDownload:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addCashDownload == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addCashDownload">Download</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Payout</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getPayoutList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getPayoutList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getPayoutList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getPayoutList">View</label>
                      </div>
                      {accessDataList?.getPayoutList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="payoutDownload"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  payoutDownload:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.payoutDownload == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="payoutDownload">Download</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Bet</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getBetList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getBetList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getBetList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getBetList">View</label>
                      </div>
                      {accessDataList?.getBetList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="betDownload"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  betDownload:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.betDownload == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="betDownload">Download</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Win</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getWinList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getWinList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getWinList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getWinList">View</label>
                      </div>
                      {accessDataList?.getWinList == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="winDownload"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  winDownload:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.winDownload == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="winDownload">Download</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Income</b>
        </h5>
        <div className="row">
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Income Details</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getIncomeList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Block Blast Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getBlockBlastIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getBlockBlastIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getBlockBlastIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getBlockBlastIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Candy Cream Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getCandyCreamIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getCandyCreamIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getCandyCreamIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getCandyCreamIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Logic Line Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getLogicLineIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getLogicLineIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getLogicLineIncomeList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getLogicLineIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Smash Block Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getSmashBlockIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getSmashBlockIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getSmashBlockIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getSmashBlockIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Tic Tac Toe Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getTicTacToeIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getTicTacToeIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getTicTacToeIncomeList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getTicTacToeIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Word Book Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getWordBookIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getWordBookIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getWordBookIncomeList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getWordBookIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Number Puzzle Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getNumberPuzzleIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getNumberPuzzleIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getNumberPuzzleIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getNumberPuzzleIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Chess Game Bit Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getChessGameBitIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getChessGameBitIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getChessGameBitIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getChessGameBitIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Classy Carrom Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getClassyCarromIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getClassyCarromIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getClassyCarromIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getClassyCarromIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Eight Ball Pool Income</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getEightBallPoolIncomeList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getEightBallPoolIncomeList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getEightBallPoolIncomeList ==
                            true
                              ? true
                              : false
                          }
                        />
                        <label for="getEightBallPoolIncomeList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Reports</b>
        </h5>
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Player List</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getReportPlayerList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getReportPlayerList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getReportPlayerList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getReportPlayerList">View</label>
                      </div>
                      {accessDataList?.getReportPlayerList == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="playerReportDownload"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                playerReportDownload:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.playerReportDownload == true
                                ? true
                                : false
                            }
                          />
                          <label for="playerReportDownload">Download</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>History List</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getReportHistoryList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getReportHistoryList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getReportHistoryList == true
                              ? true
                              : false
                          }
                        />
                        <label for="getReportHistoryList">View</label>
                      </div>
                      {accessDataList?.getReportHistoryList == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="historyReportDownload"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                historyReportDownload:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.historyReportDownload ==
                              true
                                ? true
                                : false
                            }
                          />
                          <label for="historyReportDownload">Download</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Game Setting</b>
        </h5>
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Setting</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getSetting"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getSetting:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getSetting == true
                              ? true
                              : false
                          }
                        />
                        <label for="getSetting">View</label>
                      </div>
                      {accessDataList?.getSetting == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="editSetting"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                editSetting:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.editSetting == true
                                ? true
                                : false
                            }
                          />
                          <label for="editSetting">Edit</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Social</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getSocial"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getSocial:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getSocial == true
                              ? true
                              : false
                          }
                        />
                        <label for="getSocial">View</label>
                      </div>
                      {accessDataList?.getSocial == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="editSocial"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                editSocial:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.editSocial == true
                                ? true
                                : false
                            }
                          />
                          <label for="editSocial">Edit</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Bonus</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getBonus"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getBonus:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getBonus == true
                              ? true
                              : false
                          }
                        />
                        <label for="getBonus">View</label>
                      </div>
                      {accessDataList?.getBonus == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="editBonus"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                editBonus:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.editBonus == true
                                ? true
                                : false
                            }
                          />
                          <label for="editBonus">Edit</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lsm-12 col-lg-4 col-md-4">
            <table className="m-2">
              <thead>
                <th>Game Handle</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getGameHandle"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getGameHandle:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getGameHandle == true
                              ? true
                              : false
                          }
                        />
                        <label for="getGameHandle">View</label>
                      </div>
                      {accessDataList?.getGameHandle == true && (
                        <>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="addGameHandle"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  addGameHandle:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.addGameHandle == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="addGameHandle">Add</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="editGameHandle"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  editGameHandle:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.editGameHandle == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="editGameHandle">Edit</label>
                          </div>
                          <div class="form-group m-2">
                            <input
                              type="checkbox"
                              id="deleteGameHandle"
                              onChange={(e) => {
                                setAccessDataList({
                                  ...accessDataList,
                                  deleteGameHandle:
                                    e.target.checked === true ? true : false,
                                });
                              }}
                              defaultChecked={
                                accessObject?.access?.deleteGameHandle == true
                                  ? true
                                  : false
                              }
                            />
                            <label for="deleteGameHandle">Delete</label>
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Game Version</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getGameVersion"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getGameVersion:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getGameVersion == true
                              ? true
                              : false
                          }
                        />
                        <label for="getGameVersion">View</label>
                      </div>
                      {accessDataList?.getGameVersion == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="editGameVersion"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                editGameVersion:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.editGameVersion == true
                                ? true
                                : false
                            }
                          />
                          <label for="editGameVersion">Edit</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Withdraw</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getWithdraw"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getWithdraw:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getWithdraw == true
                              ? true
                              : false
                          }
                        />
                        <label for="getWithdraw">View</label>
                      </div>
                      {accessDataList?.getWithdraw == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="editWithdraw"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                editWithdraw:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.editWithdraw == true
                                ? true
                                : false
                            }
                          />
                          <label for="editWithdraw">Edit</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>AddMoney</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="getAddMoney"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              getAddMoney:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.getAddMoney == true
                              ? true
                              : false
                          }
                        />
                        <label for="getAddMoney">View</label>
                      </div>
                      {accessDataList?.getAddMoney == true && (
                        <div class="form-group m-2">
                          <input
                            type="checkbox"
                            id="editAddMoney"
                            onChange={(e) => {
                              setAccessDataList({
                                ...accessDataList,
                                editAddMoney:
                                  e.target.checked === true ? true : false,
                              });
                            }}
                            defaultChecked={
                              accessObject?.access?.editAddMoney == true
                                ? true
                                : false
                            }
                          />
                          <label for="editAddMoney">Edit</label>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card pb-2" style={{ background: "#F5F5F5" }}>
        <h5
          className="text-center p-1"
          style={{ background: "#ECCCA6", color: "#A8684B" }}
        >
          <b>Contact Details</b>
        </h5>
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 ">
            <table className="m-2">
              <thead>
                <th>Contact</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="custom-checkbox d-flex">
                      <div class="form-group m-2">
                        <input
                          type="checkbox"
                          id="contactDetailsList"
                          onChange={(e) => {
                            setAccessDataList({
                              ...accessDataList,
                              contactDetailsList:
                                e.target.checked === true ? true : false,
                            });
                          }}
                          defaultChecked={
                            accessObject?.access?.contactDetailsList == true
                              ? true
                              : false
                          }
                        />
                        <label for="contactDetailsList">View</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <button
        style={{ width: "100px" }}
        type="submit"
        className="btn btn-primary btn-block mt-4 mr-2"
        disabled={buttonLoader}
        onClick={() => handelAddData()}
      >
        <div
          className="d-flex"
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="d-flex"
            style={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <b>Submit</b>
          </div>
          {buttonLoader && (
            <div>
              <div
                class="spinner-border ml-2 mt-1"
                role="status"
                style={{ height: "20px", width: "20px" }}
              ></div>
            </div>
          )}
        </div>
      </button>
    </div>
  );
}
